module.exports = __webpack_public_path__ + "static/1.2.B.2 CASA MERCEA RANDARE 2-dab50da2abc2707e2741787dba1aae6c.jpg";